import request from "../utils/axios";
import settings from "../settings/settings";

export const getCategories = (params) => {
    return request({ method: "GET", url: "/categories", params, baseURL: settings.catalogBaseURL });
};

export const createCategory = (data) => {
    return request({ method: "POST", url: "/categories", data, baseURL: settings.catalogBaseURL });
};

export const editCategory = (data) => {
    return request({ method: "PUT", url: "/categories", data, baseURL: settings.catalogBaseURL });
};

export const deleteCategory = (id) => {
    return request({ method: "DELETE", url: `/categories/${id}`, baseURL: settings.catalogBaseURL });
};

export const assignBazaarsToCategory = (categoryId, bazaarIds) => {
    return request({ method: "POST", url: `/categories/${categoryId}/bazaars`, data: bazaarIds, baseURL: settings.catalogBaseURL });
};

export const unassignBazaarFromCategory = (categoryId, bazaarId) => {
    return request({ method: "DELETE", url: `/categories/${categoryId}/bazaar/${bazaarId}`, baseURL: settings.catalogBaseURL });
};
